import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../models/RootState";
import { Limits, MarketGroup, MatchOdds } from "../../models/EventData";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tab,
  Button,
  Drawer,
  Box,
  Typography
} from "@mui/material";
import { addExchangeBet, fetchOpenBets, getAllmarketsData } from "../../store";
import { useParams } from "react-router-dom";
import { checkStompClientSubscriptions } from "../../websockets/websocket";
import OddButton from "./OddButton";
import Betslip from "../BetSlip/PremiumFancyBetslip";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PremiumOpenBets from "./PremiumOpenBets";
import { UserBet } from "../../models/UserBet";
import "./PremiumMarkets.scss";
import { TopicUrls } from "../../models/sportsBookState";
import { setTextColor } from "../../store/auth/authActions";
import { SportIDNameMap } from "../../constants/common-utlits";
import { DownloadForOfflineOutlined, InfoOutlined } from "@mui/icons-material";
import InplayCricket from "../../assets/rules/PremiumCricketRules.pdf";
import UpcomingCricket from "../../assets/rules/Pre Match cricket Details 2023.pdf";
import InplaySoccer from "../../assets/rules/Live odds - Soccer.pdf";
import UpcomingSoccer from "../../assets/rules/Pre-match - Soccer.pdf";
import InplayTennis from "../../assets/rules/Premium Tennis - Live.pdf";
import UpcomingTennis from "../../assets/rules/Premium Tennis - Pre Match.pdf";
// import Script from "next/script";
import { ReactComponent as LockIcon } from '../../assets/images/sports/Lock.svg';
import GeniePremiumScoreCard from "../ScoreCard/GeniePremiumScoreCard";
// import CrexScorecard from "../ScoreCard/CrexScorecard";

type StoreProps = {
  bets: any[];
  addExchangeBet: (data: any) => void;
  loggedIn: boolean;
  tabValue?: string;
  premiumEventInfo: any;
  openBetsData: UserBet[];
  loading?: boolean;
  topicUrls: TopicUrls;
  eventMarkets: MatchOdds[];
};

export const PremiumMarkets: React.FC<StoreProps> = (props) => {
  const { addExchangeBet, openBetsData, bets, premiumEventInfo, loading, topicUrls, eventMarkets } = props;
  const { sportId, competitionId } = useParams();

  const [displayMarketGroups, setDisplayMarketGroups] =
    useState<MarketGroup[]>();
  const [eventId, setEventId] = useState<string>("");
  const [tabValue, setTabValue] = React.useState("0");
  const [expanded, setExpanded] = useState([0, 1, 2, 3]);
  const [limits, setLimits] = useState<Limits>();
  const [showRules, setShowRules] = useState<boolean>(false);
  const [scorecardID, setScorecardID] = useState<string>("");
  const dispatch = useDispatch();

  const loadSportRadar = (widget: string, matchId: string) => {
  // Prevent duplicate widgets
  const old = document.getElementById("sportradar-widget-script");
  if (old) old.remove();

  const script = document.createElement("script");
  script.id = "sportradar-widget-script";

  script.innerHTML = `
(function(a,b,c,d,e,f,g,h,i){
a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},
i.l=1*new Date,
i.o=f,
g=b.createElement(c),
h=b.getElementsByTagName(c)[0],
g.async=1,
g.src=d,
g.setAttribute("n",e),
h.parentNode.insertBefore(g,h))
})(window,document,"script",
"https://ws-cdn001.akamaized.net/8ee45b574e2781d581b0b0a133803906/widgetloader",
"SIR",
{
theme:false,
language:"en"
});

SIR("addWidget",".sr-widget-1","${widget}",{
layout:"double",
scoreboard:"extended",
momentum:"extended",
collapseTo:"momentum",
activeSwitcher:"scoreDetails",
matchId:${matchId}
});
`;

  document.body.appendChild(script);
};

  const isExPremium = sessionStorage.getItem("lobbyType")?.toLowerCase() === "expremium";
  const isGeniusPremium =
    premiumEventInfo?.providerName === "GeniusPremium";

  const crexEventId = useMemo(() => {
    const raw = premiumEventInfo?.eventId;
    if (!raw) return raw;

    let candidate = raw.startsWith("sr:match:")
      ? raw.slice("sr:match:".length)
      : raw;

    let compId = premiumEventInfo?.competitionId;
    if (compId?.startsWith("sr:tournament:")) {
      compId = compId.slice("sr:tournament:".length);
    }

    if (compId && candidate.startsWith(compId)) {
      candidate = candidate.slice(compId.length);
    }

    candidate = candidate.replace(/^[:/_-]+/, "");
    return `sr:match:${candidate}`;
  }, [premiumEventInfo?.competitionId, premiumEventInfo?.eventId]);

  const geniePremiumEventId = useMemo(() => {
    const raw = premiumEventInfo?.eventId;
    if (!raw) return raw;
    return raw.startsWith("sr:match:")
      ? raw.slice("sr:match:".length)
      : raw;
  }, [premiumEventInfo?.eventId]);

  let newData = [];
  const disabledStatus = [
    "suspended",
    "closed",
    "suspended-manually",
    "deactivated",
  ];

  useEffect(() => {
    if (eventMarkets) {
      if (parseInt(tabValue) || tabValue === "0") {
        getAndSetMarkets(eventMarkets);
      } else {
        getAndSetMarkets(eventMarkets?.filter((market) => market?.category === tabValue));
      }
    } else {
      getAndSetMarkets([]);
    }
  }, [eventMarkets]);

  useEffect(() => {
    if (tabValue == "1") {
      fetchBets(premiumEventInfo?.eventId, premiumEventInfo?.sportId);
    }
    if (!parseInt(tabValue) && tabValue !== "0" && eventMarkets?.length > 0) {
      let marketsList = [...eventMarkets];

      getAndSetMarkets(marketsList?.filter((market) => market?.category === tabValue));
    } else {
      getAndSetMarkets(eventMarkets);
    }
  }, [tabValue]);

  const fetchBets = (eventId, sportId) => {
    dispatch(fetchOpenBets(eventId, sportId));
  }

  useEffect(() => {
    if (topicUrls?.prBaseUrl) {
      const topicUrlPayload: TopicUrls = {
        prBaseUrl: topicUrls?.prBaseUrl,
        prTopic: topicUrls?.prTopic
      }
      checkStompClientSubscriptions(topicUrlPayload);
    }
  }, [topicUrls]);

  const getAndSetMarkets = async (data) => {
    if (data?.length > 0) {
      let newData = [];
      data?.reduce((oldV, newV) => {
        // show marketname in same order
        let index = oldV.findIndex((item) => item.marketName === newV.marketName);

        if (oldV.length && index !== -1) {
          let mrFound = false;
          for (let mr of oldV[index].completeMarket) {
            if (mr.marketId === newV.marketId) {
              mr = newV;
              mrFound = true;
            }
          }
          if (!mrFound) {
            oldV[index] = {
              ...oldV[index],
              completeMarket: [...oldV[index].completeMarket, newV],
            };
          }
        } else {
          // If a new market comes, it will be added to it.
          oldV.push({ marketName: newV.marketName, completeMarket: [newV] });
        }
        // return array.
        return oldV;
      }, newData);

      // sorting for runnername
      for (let i = 0; i < newData.length; i++) {
        newData[i].completeMarket.sort((a, b) => {
          let x = a.marketId;
          let y = b.marketId;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
      }

      // sorting based on market name
      if (newData?.length) {
        let data = newData
          .filter(
            (item) =>
              item.marketName === "1x2" ||
              item.marketName.toLowerCase().startsWith("winner") ||
              item.marketName === "Handicap" ||
              item.marketName === "Total"
          ).sort((a, b) => {
            let oldV = a.marketName.toLowerCase().startsWith("winner")
              ? "1x2"
              : a.marketName.toLowerCase();
            let newV = b.marketName.toLowerCase().startsWith("winner")
              ? "1x2"
              : b.marketName.toLowerCase();
            if (oldV < newV) return -1;
            if (oldV > newV) return 1;
            return 0;
          });

        let finalData = data.concat(newData);
        let temp = [];
        finalData.map((i, idx) => {
          i.completeMarket.map((j) => {
            temp.push(i);
            j.runners.sort((a, b) => a.runnerId - b.runnerId);
          });
        });

        let marketList = Array.from(new Set(temp));

        // Put winner market to last of markets list for cricket
        // if (premiumEventInfo?.sportId === "sr:sport:21") {
        //   const index = marketList.findIndex(obj => obj.completeMarket[0].marketId === "340");

        //   if (index !== -1) {
        //     const [removed] = marketList.splice(index, 1);
        //     if (tabValue === "0") {
        //       marketList.push(removed);
        //     }
        //   }
        // }

        setDisplayMarketGroups(marketList);
      }
    } else {
      setDisplayMarketGroups([]);
    }

    // if (eventInfo?.markets?.matchOdds?.length === 0) setDisplayMarketGroups([]);
  };

  const handleChange = (key) => {
    let index = expanded.indexOf(key);
    if (index > -1) {
      expanded.splice(index, 1);
      setExpanded([...expanded]);
    } else {
      setExpanded([...expanded, key]);
    }
  };

  useEffect(() => {
    if (premiumEventInfo?.eventId) {
      setScorecardID(premiumEventInfo?.eventId?.split("sr:match:")?.[1]);
    }
  }, [premiumEventInfo?.eventId]);

  useEffect(() => {
    if (!scorecardID || !isExPremium || isGeniusPremium) return;

    loadSportRadar(
        premiumEventInfo?.sportId === "sr:sport:21"
            ? "match.lmtlight"
            : "match.lmtPlus",
        scorecardID
    );
}, [
    scorecardID,
    isExPremium,
    isGeniusPremium,
    premiumEventInfo?.sportId
]);

  const onTabChangeHandler = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (displayMarketGroups?.length > 0 && limits?.minBetValue === undefined) {
      setLimits({
        minBetValue: displayMarketGroups?.[0]?.completeMarket?.[0]?.limits?.minBetValue,
        maxBetValue: displayMarketGroups?.[0]?.completeMarket?.[0]?.limits?.maxBetValue
      })
    }
  }, [displayMarketGroups])

  const downloadPDF = (eventStatus, sportId) => {
    const rulesMap = {
      "inplay-cricket": InplayCricket,
      "pre-match-cricket": UpcomingCricket,
      "inplay-soccer": InplaySoccer,
      "pre-match-soccer": UpcomingSoccer,
      "inplay-tennis": InplayTennis,
      "pre-match-tennis": UpcomingTennis
    };

    fetch(rulesMap[`${eventStatus}-${SportIDNameMap[sportId]}`])
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', `${SportIDNameMap[sportId]}-${eventStatus}.pdf`);

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error fetching the PDF:', error);
      });
  };

  return (
    <>
      {
        <Typography gutterBottom component="div">
        {isExPremium ? (
          isGeniusPremium && premiumEventInfo?.catName === "SRL" ? (
            <div className="widgets">
              <GeniePremiumScoreCard eventId={premiumEventInfo?.eventId} />
            </div>
          ) : isGeniusPremium ? (
            <div className="widgets">
              <GeniePremiumScoreCard
                eventId={geniePremiumEventId}
              />
            </div>
          ) : (scorecardID || premiumEventInfo?.catId?.toLowerCase() === "sr virtual") ? (
            <div className="widgets">
              <div>
                <div className="sr-widget sr-widget-1"></div>
              </div>
            </div>
          ) : null
        ) : null}
      </Typography>
      
      }
      <div
        className="special_bets-tab-wrap ps ps--theme_default mob-view"
      >
        <div className="premium-tabs">
          <TabContext value={tabValue}>
            {
              SportIDNameMap[sportId] === "cricket" ?
                <div className="premium-tabs-ctn">
                  <TabList
                    onChange={onTabChangeHandler}
                    aria-label="lab API tabs example"
                    className="teb-list"
                    scrollButtons={false}
                    variant="scrollable"
                  >
                    <Tab label="All" value="0" className="tabs" />
                    <Tab label="Match" value="Match" className="tabs left-40" />
                    <Tab label="Innings" value="Innings" className="tabs left-60" />
                    <Tab label="Over" value="Over" className="tabs left-80" />
                    <Tab label="Player" value="Player" className="tabs left-100" />
                    <Tab label="Other" value="Other" className="tabs left-120" />
                    <Tab label="My Bets" value="1" className="tabs" />
                    
                  </TabList>
                  <Button onClick={() => setShowRules(true)} className="show-rules-btn">
                    <InfoOutlined className={setTextColor(getComputedStyle(document.body).getPropertyValue('--primary'))} />
                  </Button>
                </div>
                :
                <>
                  <TabList
                    onChange={onTabChangeHandler}
                    aria-label="lab API tabs example"
                    className="teb-list"
                  >
                    <Tab label="Markets" value="0" className="tabs" />
                    <Tab label="My Bets" value="1" className="tabs" />
                    
                  </TabList>
                  <Button onClick={() => setShowRules(true)} className="show-rules-btn">
                    <InfoOutlined className={setTextColor(getComputedStyle(document.body).getPropertyValue('--primary'))} />
                  </Button>
                    <div className={`market-limits ${setTextColor(getComputedStyle(document.body).getPropertyValue('--body-bg'))}`}>
                      Min: {limits?.minBetValue}{"  "}
                      Max: {limits?.maxBetValue}
                    </div>
                </>
            }
            {SportIDNameMap[sportId] === "cricket" && (
              <div className={`market-limits ${setTextColor(getComputedStyle(document.body).getPropertyValue('--body-bg'))}`}>
                Min: {limits?.minBetValue}{"  "}
                Max: {limits?.maxBetValue}
              </div>
            )}
            {loading ? (
              <div className="loading-overlay load-top bet-slip-loading" id="loading">
                <div className="loading-wrap" style={{ display: "flex" }}>
                  <div className="loading">
                    <div />
                    <div />
                  </div>
                  <p>Loading...</p>
                </div>
              </div>
            ) :
              (
                <>
                  <TabPanel value="0">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>

                  <TabPanel value="Over">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>

                  <TabPanel value="Innings">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>

                  <TabPanel value="Match">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>

                  <TabPanel value="Player">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>
                  <TabPanel value="Other">
                    <PremiumMarketTable
                      loading={loading}
                      premiumEventInfo={premiumEventInfo}
                      limits={limits}
                      disabledStatus={disabledStatus}
                      handleChange={handleChange}
                      bets={bets}
                      expanded={expanded}
                      displayMarketGroups={displayMarketGroups}
                      addExchangeBet={addExchangeBet}
                      tabValue={tabValue}
                    />
                  </TabPanel>

                  <TabPanel value="1">
                    <PremiumOpenBets
                      openBets={openBetsData}
                      eventName={premiumEventInfo?.eventName}
                    />
                  </TabPanel>
                </>
              )}

          </TabContext>
        </div>
      </div>
      <div id="premium-stack" className="special_bets-tab-wrap desk-view">
        <div className="premium-tabs">

          <TabContext value={tabValue}>
            {
              SportIDNameMap[sportId] === "cricket" ?
                <>
                  <TabList
                    onChange={onTabChangeHandler}
                    aria-label="lab API tabs example"
                    className="teb-list"
                  >
                    <Tab label="All" value="0" className="tabs" />
                    <Tab label="Match" value="Match" className="tabs left-20" />
                    <Tab label="Innings" value="Innings" className="tabs left-40" />
                    <Tab label="Over" value="Over" className="tabs left-60" />
                    <Tab label="Player" value="Player" className="tabs left-80" />
                    <Tab label="Other" value="Other" className="tabs left-100" />
                    <Tab label="My Bets" value="1" className="tabs left-120" />
                    
                  </TabList>
                    <Button onClick={() => setShowRules(true)} className="show-rules-btn">
                      <InfoOutlined className={setTextColor(getComputedStyle(document.body).getPropertyValue('--primary'))} />
                    </Button>
                    <div className={`market-limits ${setTextColor(getComputedStyle(document.body).getPropertyValue('--body-bg'))}`}>
                      Min: {limits?.minBetValue}{"  "}
                      Max: {limits?.maxBetValue}
                    </div>
                </>
                : <>
                  <TabList
                    onChange={onTabChangeHandler}
                    aria-label="lab API tabs example"
                    className="teb-list"
                  >
                    <Tab label="Markets" value="0" className="tabs" />
                    <Tab label="My Bets" value="1" className="tabs" />
                    
                  </TabList>
                    <Button onClick={() => setShowRules(true)} className="show-rules-btn">
                      <InfoOutlined className={setTextColor(getComputedStyle(document.body).getPropertyValue('--primary'))} />
                    </Button>
                    <div className={`market-limits ${setTextColor(getComputedStyle(document.body).getPropertyValue('--body-bg'))}`}>
                      Min: {limits?.minBetValue}{"  "}
                      Max: {limits?.maxBetValue}
                    </div>
                </>
            }

            {loading ? (
              <div className="loading-overlay load-top bet-slip-loading" id="loading">
                <div className="loading-wrap" style={{ display: "flex" }}>
                  <div className="loading">
                    <div />
                    <div />
                  </div>
                  <p>Loading...</p>
                </div>
              </div>
            ) : (
              <>
                <TabPanel value="0">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>

                <TabPanel value="Over">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>

                <TabPanel value="Innings">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>

                <TabPanel value="Match">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>

                <TabPanel value="Player">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>
                <TabPanel value="Other">
                  <PremiumMarketTable
                    loading={loading}
                    premiumEventInfo={premiumEventInfo}
                    limits={limits}
                    disabledStatus={disabledStatus}
                    handleChange={handleChange}
                    bets={bets}
                    expanded={expanded}
                    displayMarketGroups={displayMarketGroups}
                    addExchangeBet={addExchangeBet}
                    tabValue={tabValue}
                  />
                </TabPanel>

                <TabPanel value="1">
                  <PremiumOpenBets
                    openBets={openBetsData}
                    eventName={premiumEventInfo?.eventName}
                  />
                </TabPanel>
              </>
            )}

          </TabContext>
        </div>
      </div>
      <Drawer
        open={showRules}
        onClose={() => setShowRules(false)}
        className="drawer rules-drawer"
      >
        <Box
          sx={{ width: 200 }}
          role="presentation"
          onClick={() => setShowRules(false)}
          onKeyDown={() => setShowRules(false)}
        >
          <div className="box-title">Rules</div>
          <div className="rules-btn-ctn">
            <Button onClick={() => downloadPDF("inplay", sportId)} className="download-rules">
              <DownloadForOfflineOutlined color="secondary" fontSize="large" />
              <label>Inplay {SportIDNameMap[sportId]} rules</label>
            </Button>
            <Button onClick={() => downloadPDF("pre-match", sportId)} className="download-rules">
              <DownloadForOfflineOutlined color="secondary" fontSize="large" />
              <label>Pre-match {SportIDNameMap[sportId]} rules</label>
            </Button>
          </div>
        </Box>
      </Drawer>
    </>
  );
};

const Tooltip = ({ downloadPdf, text, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  return (
    <div className="tooltip-container">
      <div onClick={toggleTooltip} className="tooltip-trigger">
        {children}
      </div>
      {
        showTooltip &&
        <div className="tooltip">
          {text}
        </div>
      }
    </div>
  );
};

type PremiumMarketTableProps = {
  displayMarketGroups: MarketGroup[];
  handleChange: Function;
  addExchangeBet: (data: any) => void;
  bets: any[];
  limits: any;
  disabledStatus: any;
  loading: boolean;
  premiumEventInfo: any;
  expanded: number[];
  tabValue: string;
}

const PremiumMarketTable: React.FC<PremiumMarketTableProps> = (props) => {
  const {
    displayMarketGroups,
    handleChange,
    bets,
    limits,
    disabledStatus,
    loading,
    premiumEventInfo,
    expanded,
    addExchangeBet,
    tabValue
  } = props;

  return (
    <div className="premium-markets-table-ctn">
      <div className="pm-table-content table-ctn">
        {displayMarketGroups && displayMarketGroups.length > 0 ? (
          <>
            {displayMarketGroups?.map((marketGroup, idx) => (
                <Accordion
                    key={marketGroup?.marketName || idx}
                    expanded={expanded.indexOf(idx) > -1}
                    className="market-accordian"
                >
                    <AccordionSummary
                        onClick={() => handleChange(idx)}
                        expandIcon={
                            expanded.indexOf(idx) > -1 ? (
                                <IndeterminateCheckBoxOutlinedIcon
                                    className={`expand-icon ${setTextColor(
                                        getComputedStyle(document.body)
                                            .getPropertyValue('--table-head')
                                    )}`}
                                />
                            ) : (
                                <AddBoxOutlinedIcon
                                    className={`expand-icon ${setTextColor(
                                        getComputedStyle(document.body)
                                            .getPropertyValue('--table-head')
                                    )}`}
                                />
                            )
                        }
                        aria-controls="panel1a-content"
                    >
                        <div
                            className={`market-name ${setTextColor(
                                getComputedStyle(document.body)
                                    .getPropertyValue('--table-head')
                            )}`}
                        >
                            {marketGroup?.marketName}
                        </div>
                    </AccordionSummary>

                    <AccordionDetails>
                        <TableContainer>
                            <Table className="pm-table">
                                <TableBody>
                                    {marketGroup?.completeMarket?.map((market, marketIdx) => (
                                        <React.Fragment
                                            key={market?.marketId || marketIdx}
                                        >
                                            {market?.runners?.length > 0 ? (
                                                market.runners.map((runner, runnerIdx) => (
                                                    <PremiumMarketRow
                                                        key={
                                                            runner?.runnerId ||
                                                            `${market?.marketId}-${runnerIdx}`
                                                        }
                                                        eventData={premiumEventInfo}
                                                        matchOddsData={marketGroup}
                                                        market={market}
                                                        runner={runner}
                                                        disabledStatus={disabledStatus}
                                                        addExchangeBet={addExchangeBet}
                                                        minStake={limits?.minBetValue}
                                                        maxStake={limits?.maxBetValue}
                                                        bets={bets}
                                                    />
                                                ))
                                            ) : (
                                                <div className="lock-odds-btn">
                                                    <LockIcon className="lock-icon" />
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            ))}
          </>
        ) : (
          !loading && displayMarketGroups?.length === 0 && (
            <Table className="pm-table">
              <TableBody>
                <TableRow>
                  <TableCell colSpan={3} className="team-name-cell">
                    {tabValue ? `No premium ${tabValue === "0" ? "" : tabValue} market found.` : 'No premium market found.'}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )
        )}
      </div>
    </div>
  )
}

type PremiumMarketRowProps = {
  eventData: any;
  matchOddsData: any;
  runner: any;
  disabledStatus: string[];
  addExchangeBet: (data: any) => void;
  bets: any[];
  market: MatchOdds;
  minStake: number;
  maxStake: number;
};

const PremiumMarketRow: React.FC<PremiumMarketRowProps> = (props) => {
  const {
    matchOddsData,
    runner,
    disabledStatus,
    addExchangeBet,
    eventData,
    bets,
    market,
    minStake,
    maxStake
  } = props;

  return (
    <>
      <TableRow>
        <TableCell className="team-name-cell">
          <div className="team">{runner?.runnerName}</div>
          {/* <div>Min: {market?.limits?.minBetValue}{" "}Max: {market?.limits?.maxBetValue}</div> */}

        </TableCell>

        <TableCell className="odds-cell" align="right">
          <div className="odds-block web-view back-odds-block premium-odds-block">
            {runner.backPrices.length > 0 ? (
              runner.backPrices.map((odds, idx) => (
                <OddButton
                  mainValue={odds.price.toFixed(2)}
                  subValue={null}
                  showSubValueinKformat={true}
                  oddType="premium-odd"
                  valueType="matchOdds"
                  oddsSet={[
                    runner.backPrices[0] ? runner.backPrices[0].price : 0,
                    runner.backPrices[1] ? runner.backPrices[1].price : 0,
                    runner.backPrices[2] ? runner.backPrices[2].price : 0,
                  ]}
                  key={`${runner.runnerId}-back-${odds.price}-${idx}`}
                  disable={
                    disabledStatus?.includes(runner?.status?.toLowerCase()) ||
                    !["in_play", "upcoming"]?.includes(eventData?.eventStatus?.toLocaleLowerCase()) ||
                    disabledStatus.includes(matchOddsData?.completeMarket[0]?.status?.toLowerCase())
                  }
                  onClick={() => {
                    addExchangeBet({
                      marketName: matchOddsData.marketName,
                      marketId: market.marketId,
                      marketType: market.marketType,
                      oddValue: runner.backPrices[idx].price,
                      runnerId: runner.runnerId,
                      runnerName: runner.runnerName,
                      status: matchOddsData.status,
                      eventId: eventData.eventId,
                      eventName: eventData.eventName,
                      competitionId: eventData.competitionId,
                      betType: "BACK",
                      sessionOutcome: 0,
                      stakeAmount: 0,
                      sportId: eventData.sportId,
                      operatorId: "",
                      providerId: "",
                    });
                  }}
                />
              ))
            ) : (
              <OddButton
                subValue={null}
                showSubValueinKformat={true}
                oddType="premium-odd"
                valueType="matchOdds"
                disable={true}
              />
            )}
          </div>

          <div className="odds-block mob-view back-odds-block premium-odds-block">
            {runner.backPrices.length > 0 ? (() => {
              // Mobile: show only the highest available back price so the odds
              // always fit inside the single mobile odds column.
              const highestBack = runner.backPrices.reduce((best, current) =>
                Number(current?.price ?? 0) > Number(best?.price ?? 0) ? current : best
              );

              return (
                <OddButton
                  key={`${runner.runnerId}-mobile-back-${highestBack.price}`}
                  mainValue={highestBack.price.toFixed(2)}
                  subValue={null}
                  showSubValueinKformat={true}
                  oddType="premium-odd"
                  valueType="matchOdds"
                  disable={
                    disabledStatus?.includes(runner?.status?.toLowerCase()) ||
                    !["in_play", "upcoming"]?.includes(eventData?.eventStatus?.toLocaleLowerCase()) ||
                    disabledStatus.includes(matchOddsData?.completeMarket[0]?.status?.toLowerCase())
                  }
                  onClick={() => {
                    addExchangeBet({
                      marketName: matchOddsData.marketName,
                      marketId: market.marketId,
                      marketType: market.marketType,
                      oddValue: highestBack.price,
                      runnerId: runner.runnerId,
                      runnerName: runner.runnerName,
                      status: matchOddsData.status,
                      eventId: eventData?.eventId,
                      eventName: eventData.eventName,
                      competitionId: eventData.competitionId,
                      betType: "BACK",
                      sessionOutcome: 0,
                      stakeAmount: 0,
                      sportId: eventData.sportId,
                      operatorId: "",
                      providerId: "",
                    });
                  }}
                />
              );
            })() : (
              <OddButton
                subValue={null}
                showSubValueinKformat={true}
                oddType="premium-odd"
                valueType="matchOdds"
                disable={true}
              />
            )}
          </div>
        </TableCell>
      </TableRow>

      {bets?.[0]?.runnerName === runner.runnerName &&
        bets?.[0]?.runnerId === runner.runnerId &&
        bets?.[0]?.marketId === market.marketId ? (
        <TableRow>
          <TableCell colSpan={3}>
            {" "}
            <Betslip page={"market"} minStake={minStake} maxStake={maxStake} />{" "}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    bets: state.betslip.bets,
    eventInfo: state.sportsBook.eventInfo,
    premiumEventInfo: state.sportsBook.premiumEventInfo,
    openBetsData: state.betslip.openBets,
    loading: state.auth.loading,
    topicUrls: state?.sportsBook?.topicUrls,
    eventMarkets: getAllmarketsData(state.sportsBook.eventMarkets),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    addExchangeBet: (data: any) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumMarkets);
